import { inject, isDevMode } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

/** Blocks internal dev tools in optimized production builds (ng serve keeps dev mode). */
export const devToolsGuard: CanActivateFn = () => {
    const router = inject(Router);

    if (isDevMode()) {
        return true;
    }

    return router.createUrlTree(['/plantation']);
};
